import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { Currencies, CurrencyConverterService } from 'src/app/services/currency-converter.service';
import { Payment } from '../payment';


const paymentTypes = {
  'Nakit TL': { id: 1, tlValue: 1.02, discount: 0.2 },
  'Tek çekim': { id: 4, tlValue: 1 },
  'KK 2 taksit': { id: 5, tlValue: 0.98, commission: 0.02 },
  'KK 3 taksit': { id: 6, tlValue: 0.96, commission: 0.04 },
  'KK 4 taksit': { id: 7, tlValue: 0.94, commission: 0.06 },
  'KK 5 taksit': { id: 8, tlValue: 0.92, commission: 0.08 },
  'KK 6 taksit': { id: 9, tlValue: 0.9, commission: 0.1 },
  'KK 7 taksit': { id: 10, tlValue: 0.88, commission: 0.12 },
  'KK 8 taksit': { id: 11, tlValue: 0.86, commission: 0.14 },
  'KK 9 taksit': { id: 12, tlValue: 0.84, commission: 0.16 },
  Havale: { id: 13, tlValue: 1 },
};



@Injectable()
export class PaymentService {

  private paymentSubject = new BehaviorSubject<Payment>(new Payment(0, [], []));
  activePayment$: Observable<Payment> = this.paymentSubject.asObservable();

  private paymentTypesSubject = new BehaviorSubject(paymentTypes);
  paymentTypes$ = this.paymentTypesSubject.asObservable();

  currencies: Currencies;
  paymentTypes;

  constructor(
    private currService: CurrencyConverterService
  ) { }

  formToPaymentObj(thePaymentForm) {
    return {
      transactions: thePaymentForm.transactions,

    }
    
  }

  changePayment(pfv: Payment) {
    console.log('ps.changePayment STARTED');

    this.activePayment$.pipe(
      first(),
      tap(
        pmnt => {
          pmnt.cartTotal = pfv.cartTotal;
          pmnt.transactions = pfv.transactions;
          pmnt.additions = pfv.additions;
          console.log('PS tap 1: ', pmnt);
          this.paymentSubject.next(pmnt)
        } 
      )
    ).subscribe();
    

    // console.warn('Value changed in PS: ', newPayment);
    
  }

  getPaymentTypes() {
    this.currService.currencies$.pipe(
      first(),
      tap(curr => {
        console.log('this.getPaymentTypes working');
        let paymentTypesCombined = {...paymentTypes};
        console.log('paymentTypesCombined: ', paymentTypesCombined);
        this.currencies = curr;
        paymentTypesCombined['EURO €'] = this.currencies.EUR;
        paymentTypesCombined['USD $'] = this.currencies.USD;
        paymentTypesCombined['GBP £'] = this.currencies.GBP;
        
        this.paymentTypesSubject.next(paymentTypesCombined);
      })
      )
    .subscribe();


    
  }


}
